import { QueryClient, DefaultOptions} from '@tanstack/react-query'

export const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 3,
  },
}

export const queryClient = new QueryClient({ defaultOptions: queryConfig })